import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBot = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.8337 1.66683C10.8337 1.20659 10.4606 0.833496 10.0004 0.833496C9.54014 0.833496 9.16705 1.20659 9.16705 1.66683V5.00016L8.16741 5.00013C6.77657 4.99976 5.87709 4.99953 5.12196 5.24488C3.59977 5.73947 2.40636 6.93289 1.91177 8.45508C1.66641 9.2102 1.66665 10.1097 1.66702 11.5005V11.8331C1.66665 13.224 1.66641 14.1235 1.91177 14.8786C2.40636 16.4008 3.59977 17.5942 5.12196 18.0888C5.87708 18.3341 6.77657 18.3339 8.16739 18.3335H11.8334C13.2242 18.3339 14.1237 18.3341 14.8788 18.0888C16.401 17.5942 17.5944 16.4008 18.089 14.8786C18.3344 14.1235 18.3341 13.224 18.3337 11.8332V11.5005C18.3341 10.1097 18.3344 9.2102 18.089 8.45508C17.5944 6.93289 16.401 5.73947 14.8788 5.24488C14.1237 4.99953 13.2242 4.99976 11.8334 5.00013L10.8337 5.00016V1.66683ZM5.75033 10.8335C5.75033 9.867 6.53383 9.0835 7.50033 9.0835C8.46682 9.0835 9.25033 9.867 9.25033 10.8335C9.25033 11.8 8.46682 12.5835 7.50033 12.5835C6.53383 12.5835 5.75033 11.8 5.75033 10.8335ZM10.7503 10.8335C10.7503 9.867 11.5338 9.0835 12.5003 9.0835C13.4668 9.0835 14.2503 9.867 14.2503 10.8335C14.2503 11.8 13.4668 12.5835 12.5003 12.5835C11.5338 12.5835 10.7503 11.8 10.7503 10.8335Z",
		fill: "#18181B"
	})
});
const ForwardRef = forwardRef(SvgBot);
export default ForwardRef;
